import { render, staticRenderFns } from "./Immersive.vue?vue&type=template&id=8e57a5f8&"
import script from "./Immersive.vue?vue&type=script&lang=js&"
export * from "./Immersive.vue?vue&type=script&lang=js&"
import style0 from "./Immersive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports